import styled from 'styled-components';
import {
  detailsBackground,
} from '../../config/colors';

export const DescriptionWrapper = styled.div`
    background-color: ${detailsBackground};
    padding-left: 15px;
    padding-top: 10px;
    padding-right: 30px;
    padding-bottom: 5px;
    margin-top: 5px;
    margin-bottom: 20px;
    display: flex;
    border-radius: 3px;
    min-height: 150px;

    @media print {
      width: 61%;
      background-color: inherit;
      padding: 0 15px 0 0;
      margin-top: 0;
    }
`;

export const DescriptionText = styled.p`
  font-size: 0.875rem;
  line-height: 150%;

  @media print {
    text-align: justify;
    font-size: 1rem;
    padding-left: 10px;
  }
`;
